import sampleCombine from 'xstream/extra/sampleCombine'
import xs from 'xstream'

export function model ({pause$, slideRight$, slideLeft$, normalizedDeltaTime$, deltaTime$, defaultAcceleration$}) {
  const friction$ = pause$.map(paused =>
    paused ? 1.25 : 1.01
  )

  const acceleration$ = xs.combine(
    defaultAcceleration$,
    slideRight$,
    slideLeft$,
  )
    .map(([defaultAcceleration, slideRight, slideLeft]) => {
      if (slideRight && slideLeft) return 0
      if (slideRight) return 150
      if (slideLeft) return -150
      return defaultAcceleration
    })
    .map(x => x / 1000)

  const speed$ = normalizedDeltaTime$.compose(sampleCombine(
    friction$,
    acceleration$,
  ))
    .fold(function (currentSpeed, [normalizedDelta, friction, acceleration]) {
      return Math.min((currentSpeed + acceleration / normalizedDelta) / friction, 3)
    }, 0)
    .map(x => x * 10) // magic number so it's ± between 0 and 1
    .map(x =>  x * 15 / 1000) // max normal speed, magic number again
    .map(x => (Math.abs(x) < 2 /1000) ? 0 : x) // prevents to move when speed is really low, magic number again

  const position$ = xs.combine(deltaTime$, speed$)
    .fold((pos, [delta, speed]) => pos + speed * delta, 0)

  return position$
}

export default model



// WEBPACK FOOTER //
// ./rowSlider/model.js